import {
  AUTHORIZED_USER_DETAILS,
  CONTRACT_DETAILS_ERROR,
  CONTRACT_DETAILS_LOADER,
  CONTRACT_NUMBERS_ERROR,
  CONTRACT_NUMBERS_LOADER,
  FETCH_LEIN_DEREGISTRATION_DATA,
  GET_ALL_CONTRACTS,
  GET_CONTRACT_DETAILS,
  GET_CONTRACT_NUMBERS,
  GET_NOTIFICATIONS,
  GET_PAYMENT_SCHEDULE,
  GET_USER_DETAILS_INFO,
  INCORRECT_DATA_NAME,
  MY_ACCOUNT_DETAILS,
  NO_SCHEDULE_DATA,
  PAYMENT_SCHEDULE_ERROR,
  PAYMENT_SCHEDULE_LOADER,
  POP_STATE,
  PUSH_VIEW,
  RESET_STATE,
  RESET_VIEW,
  SERVICE_REQUEST_DETAILS,
  SERVICE_REQUEST_ERROR,
  SERVICE_REQUEST_INFO,
  DOCUMENT_REDIRECTION_INFO,
  SERVICE_REQUEST_LOADER,
  SET_CONTRACT_QUERY,
  SET_MONTH_QUERY,
  SET_ORG,
  UPDATE_ASSET_STATUS,
  SET_ROLE,
  SET_ROLE_ACCESS,
  ASK_USER_TO_ENABLE_PUSH,
} from '../actions';

const initialState = {
  viewList: ['home'],
  contractNumbers: null,
  paymentSchedule: null,
  paymentScheduleLoader: false,
  serviceRequestRedirectionData: null,
  documentRedirectionData: null,
  contractDetailsLoader: false,
  contractDetails: null,
  serviceRequestDetails: null,
  authorizedUserDetails: null,
  contractDetailsError: null,
  paymentScheduleError: null,
  queryContract: null,
  queryMonth: null,
  selectedOrg: null,
  personalExplicitlySelected: false,
  allContracts: null,
  contractNumberLoader: false,
  contractNumberError: null,
  serviceRequestLoader: false,
  serviceRequestError: null,
  myAccountDetails: null,
  lienDeregistrationData: null,
  inAppNotificationData: null,
  roleAccess: null,
  role: null,
  askForNotification: false,
};

const getUserDetailsInfo = (state, {data}) => {
  return {
    ...state,
    userDetailsInfo: data,
  };
};
const getServiceRequestInfo = (state, {data}) => {
  return {
    ...state,
    serviceRequestRedirectionData: data,
  };
};
const getDocumentRedirectionInfo = (state, {data}) => {
  return {
    ...state,
    documentRedirectionData: data,
  };
};
const getServiceRequestDetails = (state, {data}) => {
  return {
    ...state,
    serviceRequestDetails: data,
  };
};

const setSelectedOrg = (state, {data}) => {
  return {
    ...state,
    selectedOrg: data,
    personalExplicitlySelected: data === null,
  };
};

const getAuthorizedUserDetails = (state, {data}) => {
  let list;
  if (
    data.personal &&
    !state.selectedOrg &&
    !state.personalExplicitlySelected
  ) {
    list = data.personal?.authorizedList;
  } else if (Object.keys(data.org).length) {
    const selectedOrgData = data.org[0];
    list = selectedOrgData?.authorizedList;
  }

  return {
    ...state,
    authorizedUserDetails: list,
  };
};

const getIncorrectDataServiceRequest = (state, {data}) => {
  return {
    ...state,
    incorrectDataServiceRequest: data,
  };
};

const buildContractInfo = (source) => ({
  contracts: source?.accounts,
  contractCounts: source?.accounts?.length ?? 0,
  pastContracts: source?.pastAccounts,
  pastContractsCounts: source?.pastAccounts?.length ?? 0,
});

const getContractNumbers = (state, {data}) => {
  let selectedOrg = null;
  let contractInfo;

  const personalHasActive = (data.personal?.accounts?.length ?? 0) > 0;
  const hasOrgs = Object.keys(data.organisation).length > 0;

  if (state.personalExplicitlySelected) {
    contractInfo = buildContractInfo(data.personal);
  } else if (state.selectedOrg) {
    selectedOrg = state.selectedOrg;
    contractInfo = buildContractInfo(data.organisation[selectedOrg]);
  } else if (personalHasActive) {
    contractInfo = buildContractInfo(data.personal);
  } else if (hasOrgs) {
    const activeOrgKey = Object.keys(data.organisation).find(
      (key) => (data.organisation[key]?.accounts?.length ?? 0) > 0
    );

    selectedOrg = activeOrgKey || null;
    contractInfo = selectedOrg
      ? buildContractInfo(data.organisation[selectedOrg])
      : buildContractInfo(data.personal);
  } else {
    contractInfo = {
      contracts: [],
      contractCounts: 0,
      pastContracts: [],
      pastContractsCounts: 0,
    };
  }

  return {
    ...state,
    contractNumbers: contractInfo,
    selectedOrg: selectedOrg,
  };
};
const getAllContracts = (state, {data}) => {
  let allContractsData = initialState.allContracts;
  if (!data.isContractError) {
    allContractsData = data;
  }
  return {
    ...state,
    allContracts: allContractsData,
  };
};
const getPaymentScheduleError = (state, {error}) => {
  return {
    ...state,
    paymentScheduleError: error,
  };
};
const getQueryContract = (state, {contractNo}) => {
  return {
    ...state,
    queryContract: contractNo,
  };
};
const getQueryMonth = (state, {month}) => {
  return {
    ...state,
    queryMonth: month,
  };
};
const getNoScheduleData = (state, {data}) => {
  return {
    ...state,
    noScheduleData: data,
  };
};
const pushView = (state, {newView}) => {
  let newArr;
  if (state.viewList[state.viewList.length - 1] == newView) {
    newArr = [...state.viewList];
  } else {
    newArr = [...state.viewList, newView];
  }
  return {
    ...state,
    viewList: newArr,
  };
};

const popState = (state) => {
  let newArr;
  if (state.viewList.length <= 1) {
    newArr = [...state.viewList];
  } else {
    newArr = state.viewList.slice(0, -1);
  }

  return {
    ...state,
    viewList: newArr,
  };
};

const resetView = (state) => {
  return {
    ...state,
    viewList: [],
  };
};

const resetStates = (state) => {
  return {
    ...state,
    contractNumbers: null,
    paymentSchedule: null,
    contractDetails: null,
  };
};
const getPaymentSchedule = (state, {data}) => {
  return {
    ...state,
    paymentSchedule: data,
  };
};
const getPaymentScheduleLoader = (state, {data}) => {
  return {
    ...state,
    paymentScheduleLoader: data,
  };
};
const getContractDetails = (state, {data}) => {
  return {
    ...state,
    contractDetails: data,
  };
};
const getContractDetailsLoader = (state, {data}) => {
  return {
    ...state,
    contractDetailsLoader: data,
  };
};
const getContractDetailsError = (state, {error}) => {
  return {
    ...state,
    contractDetailsError: error,
  };
};
const getContractNumberError = (state, {error}) => {
  return {
    ...state,
    contractNumberError: error,
  };
};
const getContractNumberLoader = (state, {data}) => {
  return {
    ...state,
    contractNumberLoader: data,
  };
};
const getServiceRequestError = (state, {error}) => {
  return {
    ...state,
    serviceRequestError: error,
  };
};
const getServiceRequestLoader = (state, {data}) => {
  return {
    ...state,
    serviceRequestLoader: data,
  };
};

const getMyAccountDetails = (state, {data}) => {
  return {
    ...state,
    myAccountDetails: data,
  };
};

const fetchLienDeregistrationData = (state, {data}) => {
  return {
    ...state,
    lienDeregistrationData: data,
  };
};

const setInAppNotificationData = (state, {data}) => {
  return {
    ...state,
    inAppNotificationData: data,
  };
};

const setRole = (state, {data}) => {
  return {
    ...state,
    role: data,
  };
};

const setRoleAccess = (state, {data}) => {
  return {
    ...state,
    roleAccess: data,
  };
};

const updateAssetStatus = (state, {data}) => {
  const {contractNumber, serialNumber, updatedFields} = data;
  const currentData = state.lienDeregistrationData;
  if (!currentData?.[contractNumber]) {
    return state;
  }
  const updatedAssets = currentData[contractNumber].assets.map((asset) =>
    asset.serialNumber === serialNumber ? {...asset, ...updatedFields} : asset
  );
  return {
    ...state,
    lienDeregistrationData: {
      ...currentData,
      [contractNumber]: {
        ...currentData[contractNumber],
        assets: updatedAssets,
      },
    },
  };
};

const askUserToEnablePush = (state, {data}) => {
  return {
    ...state,
    askForNotification: data,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case NO_SCHEDULE_DATA:
      return getNoScheduleData(state, action);
    case GET_ALL_CONTRACTS:
      return getAllContracts(state, action);
    case SET_CONTRACT_QUERY:
      return getQueryContract(state, action);
    case SET_MONTH_QUERY:
      return getQueryMonth(state, action);
    case PAYMENT_SCHEDULE_ERROR:
      return getPaymentScheduleError(state, action);
    case INCORRECT_DATA_NAME:
      return getIncorrectDataServiceRequest(state, action);
    case GET_CONTRACT_NUMBERS:
      return getContractNumbers(state, action);
    case SERVICE_REQUEST_INFO:
      return getServiceRequestInfo(state, action);
    case DOCUMENT_REDIRECTION_INFO:
      return getDocumentRedirectionInfo(state, action);
    case SERVICE_REQUEST_DETAILS:
      return getServiceRequestDetails(state, action);
    case AUTHORIZED_USER_DETAILS:
      return getAuthorizedUserDetails(state, action);
    case GET_USER_DETAILS_INFO:
      return getUserDetailsInfo(state, action);
    case PAYMENT_SCHEDULE_LOADER:
      return getPaymentScheduleLoader(state, action);
    case GET_PAYMENT_SCHEDULE:
      return getPaymentSchedule(state, action);
    case PUSH_VIEW:
      return pushView(state, action);
    case RESET_VIEW:
      return resetView();
    case SET_ORG:
      return setSelectedOrg(state, action);
    case GET_CONTRACT_DETAILS:
      return getContractDetails(state, action);
    case CONTRACT_DETAILS_LOADER:
      return getContractDetailsLoader(state, action);
    case CONTRACT_DETAILS_ERROR:
      return getContractDetailsError(state, action);
    case CONTRACT_NUMBERS_LOADER:
      return getContractNumberLoader(state, action);
    case CONTRACT_NUMBERS_ERROR:
      return getContractNumberError(state, action);
    case SERVICE_REQUEST_LOADER:
      return getServiceRequestLoader(state, action);
    case SERVICE_REQUEST_ERROR:
      return getServiceRequestError(state, action);
    case MY_ACCOUNT_DETAILS:
      return getMyAccountDetails(state, action);
    case FETCH_LEIN_DEREGISTRATION_DATA:
      return fetchLienDeregistrationData(state, action);
    case UPDATE_ASSET_STATUS:
      return updateAssetStatus(state, action);
    case RESET_STATE:
      return resetStates(state);
    case POP_STATE:
      return popState(state);
    case GET_NOTIFICATIONS:
      return setInAppNotificationData(state, action);
    case SET_ROLE:
      return setRole(state, action);
    case ASK_USER_TO_ENABLE_PUSH:
      return askUserToEnablePush(state, action);
    case SET_ROLE_ACCESS:
      return setRoleAccess(state, action);
    default:
      return state;
  }
};

export default reducer;
